import React from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import List from "./List";
import User from "./User";

function Users(props) {
    return (
        <Switch>
            <Route exact path="/settings/users" component={List} />
            <Route exact path="/settings/users/add" render={(props) => <User {...props} mode="add" title="" />} />
            <Route exact path="/settings/users/:id" render={(props) => <User {...props} mode="detail" title="" />} />
            <Route exact path="/settings/users/:id/update" render={(props) => <User {...props} mode="update" title="" />} />
        </Switch>
    );
}

export default withRouter(Users);
